import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../translations';

import { NfzLoginFormController } from './NfzLoginForm.types';
import { useCurrentPractitionerEwusConfigurationSetCommand } from './NfzLoginSaveAction.hooks';
import { PasswordChangeEnabledFormBeanPart } from './fields/PasswordChangeEnabledField';
import { EwusEnabledFormBeanPart } from './fields/EwusEnabledField';

type EwusLoginSaveActionProps = Pick<
   NfzLoginFormController<PasswordChangeEnabledFormBeanPart<false> & EwusEnabledFormBeanPart<true>>,
   'handleSubmit'
> & { onSuccess: VoidFunction };

export const EwusLoginSaveAction = (props: EwusLoginSaveActionProps): JSX.Element => {
   const { executeAsync: setPractitionerEwusConfiguration } = useCurrentPractitionerEwusConfigurationSetCommand({
      onSuccess: props.onSuccess,
   });

   return (
      <ActionBar.PrimaryButton
         testId={'nfzLoginSave'}
         label={nfzLoginTranslationKeys.saveAndConnect}
         onClick={props.handleSubmit(setPractitionerEwusConfiguration)}
         variant={ButtonVariant.PRIMARY}
         order={1}
      />
   );
};
